import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';

import { FormModule } from 'shared/form/form.module';
import { SharedModule } from 'shared/shared.module';

import { ForgotPasswordComponent } from './forgot-password.component';
import { ForgotPasswordRoutingModule } from './forgot-password-routing.module';
import { ForgotPasswordService } from './forgot-password.service';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ForgotPasswordRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    FormModule,
  ],
  providers: [ForgotPasswordService],
  declarations: [ForgotPasswordComponent],
  exports: [ForgotPasswordComponent]
})
export class ForgotPasswordModule {}
